export default __webpack_public_path__ + "static/salon-spa-e813505e9cbbcef989aa471e5eeb1093.jpg";